<template>
  <div class="modal_box">
    <h3 class="align center">【 註冊資料 】</h3>
    <p class="align center">
      請同意成為神腦生活會員
      <br />
      系統將以您提供的手機號碼
      <b class="price">{{ mobilePhone }}</b>
      註冊成為神腦會員
    </p>
    <register-info :name-err-msg="'姓名'" :email-err-msg="'E-Mail'" :sex-err-msg="'性別'"></register-info>
    <div class="manual-canvas">
      <h5 class="title">會員服務條款及隱私權政策</h5>
      <div class="content">
        <privacy-terms-content @marketing-changed="handleMarketingOptionsChange"></privacy-terms-content>
      </div>
      <p class="spacing top sm">
        <input class="checkbox" id="checkAgreeTerms" type="checkbox" name="同意條款" v-validate="'required'" required />
        <label class="checkbox-label" for="checkAgreeTerms"> 我已閱讀並同意上述會員服務條款及隱私權政策 </label>
      </p>
      <div class="css-td" style="border: 0; padding: 0" v-if="errors && errors.has && errors.has('同意條款')">
        <p class="error">請勾選同意條款</p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" data-dismiss="modal" @click="$emit('cancel')">不同意</button>
      <button
        type="button"
        class="btn btn-secondary"
        href="javascript:void(0);"
        @click="verifyAndGetMemberRegistration">
        同意
      </button>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';
import { createRegistrationItem, sendGA4sEvent } from '@/helpers/tracking/ga';
import { useRegister } from '@/composables/register';
import { commitMutation } from '@/helpers/vuex';
import RegisterInfo from '@/components/common/modals/register-info-modal/register-info.vue';
import PrivacyTermsContent from '@/components/common/modals/register-info-modal/privacy-terms-content.vue';

export default {
  name: 'step1-member-registration',
  inject: ['$validator'],
  props: {
    mobilePhone: {
      type: String,
      default: '',
    },
  },
  components: {
    RegisterInfo,
    PrivacyTermsContent,
  },
  setup(props, context) {
    const $validator = inject('$validator');
    const { fetchRegister, focusErrorInput } = useRegister(props, context);

    /**
     * step1 表單驗證並獲取會員註冊資料
     */
    const verifyAndGetMemberRegistration = () => {
      if ($validator && $validator.validateAll) {
        $validator.validateAll().then((isVerifyResultSuccess) => {
          if (!isVerifyResultSuccess) {
            focusErrorInput($validator.errors);
            return;
          }

          sendGA4sEvent('sign_up_join', createRegistrationItem('註冊資料填寫完成', 'cart'));
          fetchRegister();
        });
      } else {
        console.error('Validator is not properly initialized');
      }
    };

    const handleMarketingOptionsChange = (options) => {
      const getMarketingPreferences = options.reduce((acc, item) => {
        acc[item.flag] = '1';
        return acc;
      }, {});
      commitMutation('OrderInfo', 'marketingOptions', getMarketingPreferences);
    };

    return {
      fetchRegister,
      verifyAndGetMemberRegistration,
      handleMarketingOptionsChange,
    };
  },
};
</script>
